import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
? 'https://easyenjaz.com/api/Applicants' 
: 'https://localhost:7122/Applicants';

// Generic headers for non-file requests (e.g., GET, DELETE)
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json', // Default content type
    },
  };
};

// Headers for file uploads (e.g., POST, PUT with FormData)
const getFileUploadHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data', // Required for file uploads
    },
  };
};

// Helper function to log FormData entries (for debugging)

// Create a new applicant
export const createApplicant = (formData) => {
  return axios.post(API_BASE_URL, formData, getFileUploadHeader());
};

// Update an existing applicant
export const updateApplicant = (id, formData) => {
  return axios.put(`${API_BASE_URL}/${id}`, formData, getFileUploadHeader());
};

// Fetch an applicant by ID
export const getApplicantById = (id) => {
  return axios.get(`${API_BASE_URL}/${id}`, getAuthHeader());
};